export const MAX_FILE_SIZE = 10 * 1024 * 1024;
export const ACCEPTED_FILE_TYPE = 'application/pdf';
export const PREVIEW_WIDTH = 160;
export const MAX_FIELD_ROW_WIDTH = 360;
export const LAYOUT_EXPAND_MS = 450;
export const ARROW_SLOT_SIZE = 32;
